import {
  Badge,
  Button,
  Checkbox,
  ConfigProvider,
  Form,
  Layout,
  List,
  Space,
  Typography,
} from "antd";
import React, { useContext, useState, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import file from "../components/download/authorization-form.pdf";
import { ThemeContext } from "../context/themeContext";
import CustomHeader from "../components/common/Header";
import { useTranslation, Trans } from "react-i18next";
import { ROUTES } from "../constants/Route";
import {LOGO_SVG_URL } from "../constants/common";

const { Title } = Typography;

const DownloadLink = () => {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();
  return (
    <a className={`${theme}-color`} href={file} download={true} size="small">
      {t("partyRequest:hipaa_authorization")}
    </a>
  );
};

const PartyRequest = () => {
  const { t, i18n } = useTranslation();
  const { Content, Footer, Header } = Layout;
  const [value, setValue] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const current = 0;

  const next = () => {
    form.validateFields();
  };

  const onhandlerequest = (requesturl) => {
    if (value) {
      navigate(requesturl);
    }
  };

  const validateAgreement = useCallback((_, value) => {
    if (value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("partyRequest:please_accept_the_agreement")));
  }, [t]);

  const validationRules = useMemo(() => ({
    agreement: [
      { validator: validateAgreement }
    ]
  }), [validateAgreement]);
  return (
    <ConfigProvider
      theme={{
        components: {
          List: {
            fontSize: 24,
            lineWidth: "0",
          },
        },
      }}
    >
      {" "}
      <Layout className="bg-white">
        <CustomHeader />
        <Content className="p-8">
          <Form 
            key={`party-request-${i18n.language}`}
            form={form}
          >
            <div className="container mx-auto followingl-list">
              <List
                size="small"
                header={
                  <Title level={3}>
                    {t(
                      "partyRequest:the_following_information_will_be_required_to_complete_the_form"
                    )}
                  </Title>
                }
                footer={
                  <Trans
                    i18nKey="partyRequest:please_note_there_may"
                    components={{
                      i: <i className="text-base" />,
                      u: <u />,
                    }}
                  />
                }
                bordered={false}
                // dataSource={data}
              >
                <List.Item className="followingl-list-item">
                  <Typography.Text>
                    <Badge color="black" style={{ marginTop: "-1rem" }} />
                  </Typography.Text>
                  <span>
                    {t("partyRequest:patient_name_and_date_of_birth")}
                  </span>
                </List.Item>
                <List.Item className="followingl-list-item">
                  <Typography.Text>
                    <Badge color="black" style={{ marginTop: "-1rem" }} />
                  </Typography.Text>
                  <span>
                    <Trans
                      i18nKey="partyRequest:completed_form_message"
                      components={{
                        0: <DownloadLink />,
                        1: <u />,
                      }}
                    />
                  </span>
                </List.Item>
              </List>
              <Form.Item
                name="agreement"
                valuePropName="checked"
                rules={validationRules.agreement}
              >
                <Space className="w-full">
                  {" "}
                  <Checkbox
                    className="font-medium"
                    onChange={() => setValue(!value)}
                  >
                    <Trans
                      i18nKey="partyRequest:i_have_all_the_required_information_to_continue_to_the_form"
                      components={{
                        span: <span className="highlight-color" />,
                      }}
                    />
                  </Checkbox>
                </Space>
              </Form.Item>

              <Space className="w-full mt-8 gap-[20px] md:gap-[100px] justify-center flex flex-col md:flex-row justify-center">
                <Button
                  type="primary"
                  // size="large"
                  className="text-[20px] p-6 w-[220px]"
                  onClick={() => {
                    current === 0 ? form.submit() : next();
                    onhandlerequest(ROUTES.SINGLE_REQUEST);
                  }}
                >
                  {t("partyRequest:single_request")}
                </Button>
                <Button
                  type="primary"
                  // size="large"
                  className="text-[20px] p-6 w-[220px]"
                  onClick={() => {
                    current === 0 ? form.submit() : next();
                    onhandlerequest(ROUTES.BULK_REQUEST);
                  }}
                >
                  {t("partyRequest:bulk_request")}
                </Button>
              </Space>

              <Space className="w-full mt-8 justify-between">
                <Link to={ROUTES.WELCOME}>
                  <Button type="primary">{t("common:back")}</Button>
                </Link>
              </Space>
            </div>
          </Form>
        </Content>
      </Layout>
      <Footer className="welcome-footer bg-white">
        <img
          className="m-auto"
          alt="Provider1st Logo"
          src={window.location.origin + LOGO_SVG_URL}
        />
      </Footer>
    </ConfigProvider>
  );
};

export default PartyRequest;
